import { Circle } from '@mui/icons-material'
import { Chip, Typography } from '@mui/material'
import { FC } from 'react'

interface GrantOutcomeChipProps {
  label: 'win' | 'loss' | 'pending'
}

const OutcomeColors = {
  win: {
    textColor: 'primary',
    backgroundColor: 'success.light',
  },
  loss: {
    textColor: 'error',
    backgroundColor: 'error.light',
  },
  pending: {
    textColor: 'secondary',
    backgroundColor: '',
  },
}

export const GrantOutcomeChip: FC<GrantOutcomeChipProps> = ({ label }) => {
  return (
    <Chip
      variant="outlined"
      icon={
        <Circle
          sx={{ fontSize: '0.4rem', mt: 0.5 }}
          color={OutcomeColors[label].textColor as any}
        />
      }
      label={
        <Typography
          fontSize="0.9rem"
          textTransform="capitalize"
          color={OutcomeColors[label].textColor}
        >
          {label}
        </Typography>
      }
      sx={{
        pl: 0.4,
        borderColor: OutcomeColors[label].backgroundColor,
        backgroundColor: OutcomeColors[label].backgroundColor,
      }}
    />
  )
}
